export default {
    'posting-type':'فصل الترحيل',
    'accountant-then-warehouser': 'محاسبي ثم مستودعي',
    'warehouser-then-accountant':'مستودعي ثم محاسبي',
    'no-priority': 'دون اولوية',
    'customize-financial-files': 'تخصيص ملفات مالية',
    'customized-financial-files': 'الملفات المالية المخصصة',
    'customize-setting': "تخصيص إعداد",
    'setting-name': 'اسم الإعداد',
    'un-customize-setting': 'إلغاء تخصيص إعداد',
    'un-customize-setting-description': 'هل أنت متأكد من إالغاء تخصيص هذه الإعدادة مع العلم أنه سيتم تطبيق حالة الإعدادة على مستوى النظام',
    'un-customize': "إلغاء تخصيص",
    'Posting Pattern': {
        "title": ' أولوية الترحيل',
        "icon": '<i class="fas fa-sort-amount-down-alt primary--text"></i>'
    },
    'showCounterAccount': {
        "title": "عرض الحساب المقابل",
        "icon": '<i class="fas fa-user-alt primary--text"></i>'
    },
    "useAltCurrencyBalancing": {
        "title" : "موازنة السندات بالعملة البديلة",
        "icon": '<i class="fas fa-balance-scale primary--text"></i>'
    } ,
    "QtyColor": {
        "title": " انذار الكمية عند تجاوز حدود المادة ",
        "icon": '<i class="fas fa-exclamation-circle primary--text"></i>'
    },
    "ValidateAccountType": {
        "title": "تقييد الحسابات الختامية - متاجرة فقط",
        "icon": "<i class='fas fa-user-alt-slash primary--text'></i>"
    },
    "UseDocNoInsteadOfInvoiceNo" : {
        "title": "اظهار رقم المستند اليدوي عوضا عن رقم الفاتوره في كشف استاذ",
        "icon": "<i class='mdi mdi-numeric primary--text text-h5'></i>"
    },
    "ShowDateEntry": {
        "title": "اظهار حقل تاريخ القيد وامكانية تعديله في اليومية المحاسبية والنقدية",
        "icon": "<i class='fas fa-calendar-alt primary--text'></i>"
    },
    "CanAddFutureDate": {
        "title": "إمكانية إضافة تواريخ مستقبلية للفواتير والبنود",
        "icon": "<i class='mdi mdi-sort-calendar-descending primary--text text-h5'></i>"
    },
    "ReverseCurrencyPrice": {
        "title": "تبديل اتجاه حساب سعر العملة  ضمن اليوميه المحاسبية والنقدية عند استخدام عملة مغايرة لعملة النظام",
        "icon": "<i class='mdi mdi-swap-vertical primary--text text-h5'></i>" 
    },
    "UseMaterialSerialNumber": {
        "title": "عرض الرقم التسلسلي ل مادة ضمن الفواتير",
        "icon": "<i class='mdi mdi-barcode-scan primary--text text-h5 mt-2'></i>"
    },
    "ShowMaterialSpecifications": {
        "title": "عرض مواصفات المادة ضمن الفواتير وعرض سعر",
        "icon": "<i class='fas fa-info primary--text me-1'/>"
    },
    "DuplicateSerialNumAlert": {
        "title": "تنبيه تكرار الرقم التسلسلي بين المواد",
        "icon": "<i class='far fa-clone primary--text me-1'></i>"
    },
    "UseRandomNumber": {
        "title": "ترميز رقم عرض السعر عند الطباعة",
        "icon": "<i class='mdi mdi-counter primary--text text-h5 mt-2'></i>"
    },
    "UseInvoiceDateInsteadOfCurrentDate": {
        "title": "استخدام تاريخ الفاتورة بدلا من تاريخ اليوم عند التصدير",
        "icon": "<i class='mdi mdi-calendar primary--text text-h5 mt-2'></i>"
    },
    "ProfessionalAccountingColorMode": {
        "title": "نمط التلوين المتقدم",
        "icon": "<i class='mdi mdi-palette-advanced primary--text me-1'></i>"
    },
    "hideDeleteBondButton": {
        "title": "إخفاء زر الحذف في اليومية المحاسبية والنقدية",
        "icon": "<i class='fas fa-trash-alt primary--text me-1'></i>"
    }
}